// extracted by mini-css-extract-plugin
export default {"search":"index_search_9fxaG","searchInput":"index_searchInput_FDG47","searchBtn":"index_searchBtn_8k-Ma"};